import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal.vue?vue&type=template&id=4d20ae4a&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal.scss?vue&type=style&index=0&id=4d20ae4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20ae4a",
  null
  
)

export default component.exports